import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Invite } from './invites.model';
import { Enrollment } from '../enrollments/enrollments.model';
import { Page } from '../@shared.model';
import { User } from '../users/users.model';

export type InviteStatus = 'ACTIVE' | 'COMPLETED' | 'DELETED' ;





@Injectable({
  providedIn: 'root'
})
export class InvitesService {

  constructor(private http: HttpClient) {
  }

  getInvite(code: string): Observable<Invite> {
    return this.http.get<Invite>(
      `${environment.apiHost}/invites/${code}`
    ) ;
  }

  acceptInvite(code: string): Observable<Enrollment> {
    return this.http.post<Enrollment>(
      `${environment.apiHost}/invites/${code}/acceptees`,
      {}
    )
  }

  getMyAcceptance(code: string): Observable<Enrollment> {

    return this.http.get<Enrollment>(
      `${environment.apiHost}/invites/${code}/acceptees/me`
    ) ;
  }

  getAcceptances(code: string, page?: number): Observable<Page<User>> {

    let params = {
      page: (page) ? page : 0
    }

    return this.http.get<Page<User>>(
      `${environment.apiHost}/invites/${code}/acceptees`,
      {params}
    ) ;
  }
  
  
}
